import {createAction} from 'web-app/util/redux/famly-app-helpers';

const domain = 'CHILD_PROFILE/GROUPS';

export const {
    action: confirming,
    success: confirmingSuccess,
    failed: confirmingFailed,
} = createAction(`${domain}/CONFIRMING`, loadingDate => ({loadingDate}));

export const {action: showModal} = createAction(`${domain}/SHOW_MODAL`, (show, statePeriod) => ({show, statePeriod}));
